var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"entry"},[_c('van-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},_vm._l((_vm.typeList),function(type){return _c('van-tab',{key:type.id,attrs:{"title":type.categoryName,"name":type.id}})}),1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }